(function() {
'use strict';

angular
    .module('TR')
    .controller('HotelsSort', HotelsSort);

function HotelsSort($scope, hotelSearch, preferences) {
    const hs = this;

    preferences.getHotelSortOrder().then(function(so) {
        hs.SortCriterion = so;

        $scope.$watch('hs.SortCriterion', function(f, o) {
            if (f == null || f === o) {
                return;
            }
            hotelSearch.sort(f);
        }, true);
    });
}
})();
